import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound: React.FC = () => {
    const styles: { [key: string]: React.CSSProperties } = {
        container: {
            textAlign: 'center',
            padding: '5rem 1rem',
            fontFamily: 'Arial, sans-serif',
        },
        title: {
            fontSize: '3rem',
            color: '#ff6600',
            marginBottom: '1rem',
        },
        message: {
            fontSize: '1.25rem',
            marginBottom: '2rem',
            color: '#444',
        },
        link: {
            fontSize: '1rem',
            color: '#007bff',
            textDecoration: 'none',
        },
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>404 - Page Not Found</h1>
            <p style={styles.message}>
                The page you are looking for doesn’t exist or has been moved.
            </p>
            <Link to="/" style={styles.link}>
                ← Back to Home
            </Link>
        </div>
    );
};
